import { HireTypePropertyEnum } from '../../../enums/residential-occupations.enum';
import { PropertyWalletItemDTO } from '../../../services/properties';
import { hirePropertyTypeOptions } from '../types';

const normalizeTypeValue = (value?: string): string =>
  (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();

const propertyServiceCodeToHireType: Record<string, string> = {
  TYPE_HOUSE: HireTypePropertyEnum.standardHouse,
  TYPE_APARTMENT: HireTypePropertyEnum.apartment,
  TYPE_CONDO_HOUSE: HireTypePropertyEnum.standardHouse,
  TYPE_PENTHOUSE: HireTypePropertyEnum.roof,
  TYPE_FARMHOUSE: HireTypePropertyEnum.standardHouse,
  TYPE_DUPLEX: HireTypePropertyEnum.apartment,
  TYPE_KITNET: HireTypePropertyEnum.kitnet,
  TYPE_LOFT: HireTypePropertyEnum.loft,
  TYPE_GROUND: HireTypePropertyEnum.ground,
  TYPE_COMMERCIAL_COMPLEX: HireTypePropertyEnum.roomSet,
  TYPE_COMMERCIAL_LAND: HireTypePropertyEnum.ground,
  TYPE_SHED: HireTypePropertyEnum.pavilion,
  TYPE_LIVING_ROOM: HireTypePropertyEnum.commercialRoom,
  TYPE_STORE: HireTypePropertyEnum.commercialStore,
  TYPE_GARAGE: HireTypePropertyEnum.commercialStore,
  TYPE_BUILDING: HireTypePropertyEnum.edifice
};

const descriptionMatchers: Array<{ pattern: RegExp; value: string }> = [
  { pattern: /apartamento|apt\b/i, value: HireTypePropertyEnum.apartment },
  { pattern: /kitnet|kitinete/i, value: HireTypePropertyEnum.kitnet },
  { pattern: /cobertura/i, value: HireTypePropertyEnum.roof },
  { pattern: /sobrado/i, value: HireTypePropertyEnum.loft },
  { pattern: /loja/i, value: HireTypePropertyEnum.commercialStore },
  { pattern: /sala/i, value: HireTypePropertyEnum.commercialRoom },
  { pattern: /terreno/i, value: HireTypePropertyEnum.ground },
  { pattern: /galpao|pavilhao/i, value: HireTypePropertyEnum.pavilion },
  { pattern: /predio|edificio/i, value: HireTypePropertyEnum.edifice },
  { pattern: /casa/i, value: HireTypePropertyEnum.standardHouse }
];

const matchHireOption = (candidates: string[]): string | undefined => {
  const option = hirePropertyTypeOptions.find(current => {
    const optionValue = normalizeTypeValue(String(current.value));
    const optionText = normalizeTypeValue(String(current.text));
    return candidates.some(
      candidate => candidate === optionValue || candidate === optionText
    );
  });

  return option ? String(option.value) : undefined;
};

export const mapWalletPropertyTypeToHireType = (
  item: PropertyWalletItemDTO,
  fallback?: string
): string | undefined => {
  const code = normalizeTypeValue(item?.type?.code);
  const description = normalizeTypeValue(item?.type?.description);

  if (code && propertyServiceCodeToHireType[code]) {
    return propertyServiceCodeToHireType[code];
  }

  const directMatch = matchHireOption([code, description].filter(Boolean));
  if (directMatch) return directMatch;

  const rawDescription = item?.type?.description || '';
  const keywordMatch = descriptionMatchers.find(({ pattern }) =>
    pattern.test(rawDescription)
  );
  if (keywordMatch) return keywordMatch.value;

  return fallback;
};
